import { Resource } from 'src/app/global/domain/resource.model';

export class Cliente extends Resource {
  numCliente: string;
  documento: string;
  apelido: string;
  nome: string;
  data: Date;
}
